<template>
  <div class="add-folder-item-pop-w">
    <div class="project-pop-card">
      <div class="title-w">
        <div class="title">Create New</div>
        <div class="close-pop">
          <i class="el-icon-close" @click="$emit('close-add-pop')"></i>
        </div>
      </div>

      <el-alert :title="popError" type="error" center v-show="popError"></el-alert>

      <div class="step-1-w" v-if="currentStep === 'SELECT'">
        <el-button
          round
          style="margin-right: 8vw;"
          type="primary"
          @click="afterSelect('FOLDER')"
          v-if="folder === null"
        >Folder</el-button>
        <el-button
          type="primary"
          :plain="folder !== null ? false : true"
          round
          @click="afterSelect('ITEM')"
        >Item</el-button>
        <el-button
          type="primary"
          plain
          round
          style="margin-left: 8vw;"
          @click="afterSelect('IMAGE')"
          v-if="folder !== null"
        >Image</el-button>
      </div>
      <div class="step-2-w">
        <div class="folder-pop" v-if="currentStep === 'FOLDER'">
          <div class="question">Folder Name</div>
          <el-input placeholder="Name for new folder" v-model="folderNameInput"></el-input>
          <div class="input-error" v-show="folderNameError">This folder already existed.</div>
          <div style="text-align: center; margin-top: 16px">
            <el-button
              round
              type="primary"
              style="margin-top: 16px; margin-bottom: 12px"
              @click="addNewFolder()"
              :disabled="folderNameError || folderNameInput === ''"
            >Create Folder</el-button>
          </div>
        </div>
        <div class="item-pop" v-if="currentStep === 'ITEM'">
          <div class="item-index">{{newItemIndex < 10 ? '0' : ''}}{{newItemIndex}}</div>
          <!-- <div class="question">Item name</div>
          <el-input v-model="newItemName" placeholder="Your Item Name" @focus="inputError.newItemName = ''"></el-input>
          <div v-if="inputError.newItemName">{{inputError.newItemName}}</div>-->
          <div class="question" style="margin-top: 16px;">Select a template</div>
          <el-select
            v-model="selectedTemplateId"
            v-if="formTemplateList.length > 6"
            placeholder="Select a template"
            @change="inputError.selectedTemplateId = ''"
          >
            <el-option
              v-for="template in formTemplateList"
              :key="template.templateId"
              :label="template.templateName"
              :value="template.templateId"
            ></el-option>
          </el-select>
          <!-- Quick Select-->
          <div v-else class="quick-select-tag">
            <div
              v-for="template in formTemplateList"
              :key="template.templateId"
              :class="selectedTemplateId === template.templateId ? 'selected tag' : 'tag'"
              @click="selecteTemplate(template.templateId)"
            >{{template.templateName}}</div>
          </div>
          <div v-if="inputError.selectedTemplateId">{{inputError.selectedTemplateId}}</div>
          <div style="text-align: center; margin-top: 16px">
            <el-button
              round
              type="primary"
              style="margin-top: 16px; margin-bottom: 12px"
              @click="createItem()"
            >Create Item</el-button>
          </div>
        </div>

        <div class="image-pop" v-if="currentStep === 'IMAGE'">
          <div class="question">Add / Remove images</div>
          <item-image-input v-model="folder.images"></item-image-input>
          <el-button type="primary" round @click="saveEditImage()" style="margin-top: 12px;">Save</el-button>
          <el-button round @click="$emit('close-add-pop')" style="margin-top: 12px;">Cancel</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemImageInput from './ItemImageInput.vue'

export default {
  name: 'AddFolderItemPop',
  props: ['folder', 'newItemIndex'],
  model: {
    prop: 'folder',
    event: 'change'
  },
  components: { ItemImageInput },
  data () {
    return {
      currentStep: 'SELECT',
      folderNameInput: '',
      addFolderLoading: false,
      selectedTemplateId: '',
      creatingItem: false,
      newItemName: '',
      inputError: {
        newItemName: '',
        selectedTemplateId: ''
      },
      popError: ''
    }
  },
  methods: {
    afterSelect: function (userSelect) {
      this.currentStep = userSelect
    },
    addNewFolder: async function () {
      if (this.folderNameError || this.folderNameInput === '') {
        return
      }
      this.addFolderLoading = true
      let addResult = await this.$store.dispatch(
        'addNewFolder',
        this.folderNameInput
      )
      this.addFolderLoading = false
      if (addResult.success) {
        this.$message.success('New Folder Added')
      } else {
        this.$message.error(addResult.error)
      }
      this.$emit('close-add-pop')
    },
    createItem: async function () {
      let validForm = true
      if (!this.selectedTemplateId) {
        this.inputError.selectedTemplateId = 'Please select a template'
        validForm = false
      }
      // item name now is optional
      // if (!this.newItemName) {
      //   this.inputError.selectedTemplateId = 'Please enter item name'
      //   validForm = false
      // }
      if (!validForm) {
        return
      }
      // vuex will matain the current project Id, so only folder id is needed, folder may be null is pop triggered under project root page
      let addItemRequest = {
        folderId: this.folder ? this.folder.id : null,
        RF: this.folder ? this.folder.name : '',
        templateId: this.selectedTemplateId,
        newItemName: this.newItemName
      }
      this.creatingItem = true
      let addItemResult = await this.$store.dispatch(
        'addNewItem',
        addItemRequest
      )
      if (addItemResult.success) {
        this.creatingItem = false
        this.$emit('close-add-pop')
        // console.log(addItemResult)
        this.$store.commit('setEditingItem', addItemResult.item)
        window.scrollTo(0, 0)
      } else {
        this.creatingItem = false
        this.popError = addItemResult.error
      }
    },
    selecteTemplate: function (templateId) {
      this.selectedTemplateId = templateId
    },
    saveEditImage: async function () {
      if (!this.folder) {
        this.popError = 'Unknon error, please try again later'
        return
      }
      let setFolderResult = await this.$store.dispatch('setFolder', this.folder)
      if (setFolderResult.success) {
        this.$message.success('Saved')
        this.$emit('close-add-pop')
      } else {
        this.popError = setFolderResult.error
      }
    }
  },
  computed: {
    folderNameError: function () {
      return this.existedFolderName.includes(this.folderNameInput)
    },
    existedFolderName: function () {
      return this.$store.state.currentFolders.map(folder => {
        return folder.name
      })
    },
    formTemplateList: function () {
      return this.$store.state.formTemplates
    },
    currentProject: function () {
      return this.$store.state.currentProject
    }
  }
}
</script>

<style scoped>
/* .folder-button {
  display: inline-block;
  width: 20vw;
  max-width: 200px;
  height: 20vw;
  max-height: 200px;
  border: 1px solid black;
}
.item-button {
  display: inline-block;
  width: 20vw;
  max-width: 200px;
  height: 20vw;
  max-height: 200px;
  border: 1px solid black;
} */

.step-1-w {
  text-align: center;
  margin: 24px 0;
}
.item-index {
  font-size: 3em;
  font-weight: bold;
  color: #409eff;
}

.quick-select-tag {
  margin-top: 12px;
}

.tag {
  display: inline-block;
  cursor: pointer;
  /* height: 32px; */
  font-size: 14px;
  padding: 10px 15px;
  line-height: 16px;
  border-radius: 20px;
  color: #1e88e5;
  font-weight: bold;
  border: solid 1px #1e88e5;
  margin: 6px;
  box-sizing: border-box;
  vertical-align: middle;
  transition: all 0.3s ease
}

.selected {
  background-color: #1e88e5;
  color: #ffffff;
}
</style>
